{
  "dss": {
    "footer": {
      "legalEntity": "ANDREAS STIHL NV, Veurtstraat 117, 2870 Puurs-Sint-Amands, België/Belgique, VAT Number: BE 0427.714.768"
    },
    "link": {
      "contact": "https://support.stihl.com/fr-BE/websso-contact/",
      "faq": "https://support.stihl.com/fr-BE/externalkbsearchwebsso/"
    },
    "page": {
      "postPwSet": {
        "link_name": "Retourner sur stihl.be",
        "link_url": "https://www.stihl.be"
      }
    }
  }
}
